export default function initialState() {
    return {
        designations: {
            __loading__: false,
            __error__: null
        }
    };
}
